import React from 'react';
import { Mail, MessageCircle, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-secondary text-white py-16 px-6 md:px-12" data-testid="footer">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              EasyOrder
            </h3>
            <p className="text-white/80 leading-relaxed">
              Automate your fast food delivery orders. Stop losing money. Start making more.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Product
            </h4>
            <ul className="space-y-3">
              <li><a href="#features" className="text-white/80 hover:text-white transition-colors">Features</a></li>
              <li><a href="#pricing" className="text-white/80 hover:text-white transition-colors">Pricing</a></li>
              <li><a href="#testimonials" className="text-white/80 hover:text-white transition-colors">Case Studies</a></li>
              <li><a href="#how-it-works" className="text-white/80 hover:text-white transition-colors">How It Works</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Company
            </h4>
            <ul className="space-y-3">
              <li><a href="#faq" className="text-white/80 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="https://app.easyorder.delivery/login" className="text-white/80 hover:text-white transition-colors">Login</a></li>
              <li><a href="https://app.easyorder.delivery/informacoes" className="text-white/80 hover:text-white transition-colors">Sign Up</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Get in Touch
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/80">
                <Mail className="w-5 h-5" />
                hello@easyorder.ai
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <MessageCircle className="w-5 h-5" />
                WhatsApp Support
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <MapPin className="w-5 h-5" />
                Global (Remote Team)
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © 2026 EasyOrder. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors">Terms of Service</a>
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;